import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fts-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadMoreComponent {
  @Input()
  text: string;
  @Input()
  readMoreText = this.translateService.instant('component.read_more.more');
  @Input()
  readLessText = this.translateService.instant('component.read_more.less');
  @Input()
  limit = 60;
  @Input()
  showButton = true;

  truncated = true;

  constructor(private translateService: TranslateService) {}

  toggleTruncated() {
    this.truncated = !this.truncated;
  }
}
